import { Component, ViewChild, Input, OnInit } from '@angular/core'

import { Subject } from 'rxjs/Subject'

import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { User } from '../../models/user.model'
import { RelationshipForm } from '../../models/relationship-form.model'
import { Relationship, RelationshipType } from '../../models/relationship.model'

@Component({
  selector: 'ld-user-relation',
  template: require('./user-relation.component.html'),
  styles: [require('./user-relation.component.css')]
})
export class UserRelationComponent implements OnInit {
  @Input('adding') adding = false
  @Input('userId') userId = ''
  @Input('relationships') relationships: RelationshipForm[] = []
  private newRelationship = new RelationshipForm()

  constructor (
    private usersService: UsersService,
    private messagesDelegate: MessagesDelegate) { }

  ngOnInit () {
    this.newRelationship.userId = this.userId
  }

  addRelationship () {
    if (this.newRelationship.relatedUser.firstname === '' || this.newRelationship.relationship === '') return

    // 2 parents max
    const parentsCount = this.relationships.reduce((acc, el) => RelationshipType[el.relationship] === RelationshipType.parent ? acc + 1 : acc, 0)
    if (this.newRelationship.relationship === RelationshipType[RelationshipType.parent] && parentsCount === 2 ) {      
      this.messagesDelegate.add('APP.RELATIONSHIP.PARENT_LIMIT_EXCEEDED')
      return false
    }

    if (this.relationships.find((rel) => rel.relatedUser.id === this.newRelationship.relatedUser.id)) {
      this.messagesDelegate.add('APP.RELATIONSHIP.USER_LIMIT_EXCEEDED')
      return false
    }

    // only one relation per user
    if (this.relationships.find((rel) => rel.relatedUser.id === this.newRelationship.relatedUser.id)) {
      this.messagesDelegate.add('APP.RELATIONSHIP.USER_LIMIT_EXCEEDED')
      return false
    }

    this.relationships.push(this.newRelationship)
    this.newRelationship = new RelationshipForm()
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/user-relation/user-relation.component.ts